import { isRouteErrorResponse, useRouteError } from 'react-router';
import { ButtonLink, Logo } from '../../components/ui';
import styles from './common.module.css';

/** Last-resort screen for render errors and failed lazy chunks (e.g. after a deploy). */
export function RouteError() {
  const error = useRouteError();
  const notFound = isRouteErrorResponse(error) && error.status === 404;
  return (
    <main className={styles.page}>
      <Logo />
      <h1 className={styles.title}>{notFound ? 'Страница не найдена' : 'Что-то пошло не так'}</h1>
      <p className={styles.text}>
        {notFound ? 'Проверьте адрес или вернитесь на главную.' : 'Обновите страницу — если ошибка повторится, попробуйте позже.'}
      </p>
      <div className={styles.actions}>
        <ButtonLink to="/" variant="secondary" reloadDocument>
          На главную
        </ButtonLink>
      </div>
    </main>
  );
}
